import { render, staticRenderFns } from "./ImpersonationDialog.vue?vue&type=template&id=08b338b4&"
import script from "./ImpersonationDialog.vue?vue&type=script&lang=js&"
export * from "./ImpersonationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports